import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'
import LayoutSidebarless from '../views/admin/layout/LayoutSidebarless'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/imstijarah/register', component: () => import('@/views/imstijarah/register'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
  { path: '/egate', component: () => import('@/views/imstijarah/public'), hidden: true },
  { path: '/a', component: () => import('@/views/imstijarah/productpublic'), hidden: true },
  { path: '/public/:companytag', component: () => import('@/views/sipp/productpublic'), hidden: true },
  { path: '/warranty/:companytag', component: () => import('@/views/sipp/warrantypublic'), hidden: true },
  { path: '/imsteknobumi/warranty', component: () => import('@/views/imsteknobumi/warrantypublic'), hidden: true },
  { path: '/ainmedicare/gantry1', component: () => import('@/views/ainmedicare/gantry1view'), hidden: true },
  { path: '/ainmedicare/gantry2', component: () => import('@/views/ainmedicare/gantry2view'), hidden: true },
  { path: '/ainmedicare/scan1', component: () => import('@/views/ainmedicare/scan1view'), hidden: true },
  { path: '/p/inbound/:companytag', component: () => import('@/views/sipp/inboundview'), hidden: true },
  { path: '/p/outbound/:companytag', component: () => import('@/views/sipp/outboundview'), hidden: true },

  // Archive Versions
  // v1
  { path: '/v/v1/login', component: () => import('@/views/home/v1/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const asyncRouterMap = [
  // {
  //   path: '/z/:branchId/notification',
  //   component: Layout,
  //   redirect: 'notification',
  //   name: 'Notification',
  //   meta: { title: 'Notification', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/notification/index'),
  //       meta: { title: 'Notification', icon: 'ow_clock1', badge: 'notification' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/imstijarah/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'imstijarah', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/imstijarah/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/imstijarah/reporting'),
        meta: { relationRoles: ['Owner'], title: 'Reporting', icon: 'ow_clock1' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/imstijarah/productstocks'),
        meta: { relationRoles: ['Owner'], title: 'Stock Control', icon: 'ow_clock1' }
      },
      // {
      //   path: 'productinventories',
      //   component: () => import('@/views/imstijarah/productinventories'),
      //   meta: { relationRoles: ['Owner'], title: 'Stock Control', icon: 'ow_clock1' }
      // },
      {
        path: 'transactionlogs',
        component: () => import('@/views/imstijarah/transactionlogs'),
        meta: { relationRoles: ['Owner'], title: 'Transaction Logs', icon: 'ow_clock1' }
      },
      // {
      //   path: 'productlist',
      //   component: () => import('@/views/imstijarah/productlist'),
      //   meta: { relationRoles: ['Owner'], title: 'Product List', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'distributorlist',
      //   component: () => import('@/views/imstijarah/distributorlist'),
      //   meta: { relationRoles: ['Owner'], title: 'Distributor List', icon: 'ow_clock1' }
      // },
      {
        path: 'distributorlist',
        component: () => import('@/views/imstijarah/distributors'),
        meta: { relationRoles: ['Owner'], title: 'Distributor List', icon: 'ow_clock1' }
      },
      // {
      //   path: 'productsales',
      //   component: () => import('@/views/imstijarah/productsales'),
      //   meta: { relationRoles: ['Owner'], title: 'Sale', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'reporting',
      //   component: () => import('@/views/imstijarah/reportingdistributor'),
      //   meta: { relationRoles: ['Distributor'], title: 'Reporting', icon: 'ow_clock1' }
      // },
      {
        path: 'distributorinventories',
        component: () => import('@/views/imstijarah/distributorinventories'),
        meta: { relationRoles: ['Distributor'], title: 'Inventory', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imstijarah/weniaga',
    component: Layout,
    redirect: '',
    name: 'WeNiaga',
    meta: { relationRoles: ['Owner'], feature: 'imstijarah', title: 'WeNiaga', icon: 'ow_clock1' },
    children: [
      {
        path: 'weniagadashboard',
        component: () => import('@/views/imstijarah/weniagadashboard'),
        meta: { title: 'WeNiaga Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'weniagaproducts',
        component: () => import('@/views/imstijarah/weniagaproducts'),
        meta: { title: 'WeNiaga Products', icon: 'ow_clock1' }
      },
      {
        path: 'weniagaorders',
        component: () => import('@/views/imstijarah/weniagaorders'),
        meta: { title: 'WeNiaga Orders', icon: 'ow_clock1' }
      },
      {
        path: 'weniagadeliveryorders',
        component: () => import('@/views/imstijarah/weniagadeliveryorders'),
        meta: { title: 'WeNiaga Delivery Orders', icon: 'ow_clock1' }
      },
      {
        path: 'weniagausers',
        component: () => import('@/views/imstijarah/weniagausers'),
        meta: { title: 'WeNiaga Users', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imstijarah/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { relationRoles: ['Owner'], feature: 'imstijarah', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'products',
        component: () => import('@/views/imstijarah/products'),
        meta: { title: 'Products', icon: 'ow_clock1' }
      },
      {
        path: 'bom',
        component: () => import('@/views/imstijarah/finishedgoods'),
        meta: { title: 'BOM', icon: 'ow_clock1' }
      },
      {
        path: 'distributors',
        component: () => import('@/views/imstijarah/distributors'),
        meta: { title: 'Distributors', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/imstijarah/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imstijarah/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { relationRoles: ['Owner'], feature: 'imstijarah', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'workorders',
        component: () => import('@/views/imstijarah/workorders'),
        meta: { title: 'Set Orders', icon: 'ow_clock1' }
      },
      {
        path: 'returnscanlogs',
        component: () => import('@/views/imstijarah/returnscanlogs'),
        meta: { title: 'Return Set Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'incomingproductlogs',
        component: () => import('@/views/imstijarah/incomingproductlogs'),
        meta: { title: '01 Incoming Product Logs', icon: 'ow_clock1' }
      },
      {
        path: 'productbatches',
        component: () => import('@/views/imstijarah/productbatches'),
        meta: { title: '02 Generate Batch QR', icon: 'ow_clock1' }
      },
      {
        path: 'productwarehousescanlogs',
        component: () => import('@/views/imstijarah/productwarehousescanlogs'),
        meta: { title: '03 Product Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'productwarehouses',
        component: () => import('@/views/imstijarah/productwarehouses'),
        meta: { title: '04 Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'cartonqrcodes',
        component: () => import('@/views/imstijarah/cartonqrcodes'),
        meta: { title: '05 Generate Carton QR', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartonscanlogs',
        component: () => import('@/views/imstijarah/packedcartonscanlogs'),
        meta: { title: '06 Carton Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartons',
        component: () => import('@/views/imstijarah/packedcartons'),
        meta: { title: '07 Packed Cartons', icon: 'ow_clock1' }
      },
      {
        path: 'purchaseorders',
        component: () => import('@/views/imstijarah/purchaseorders'),
        // meta: { title: '15 Admin Requests', icon: 'ow_clock1', badge: 'purchaseorder' }
        meta: { title: '08 Admin Requests', icon: 'ow_clock1' }
      },
      {
        path: 'packinglistpair',
        component: () => import('@/views/imstijarah/packinglistscanlogs'),
        meta: { title: '09 Packing List Simulator', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imstijarah/distributor',
    component: Layout,
    redirect: '',
    name: 'Distributor',
    meta: { relationRoles: ['Distributor'], feature: 'imstijarah', title: 'Distributor', icon: 'ow_clock1' },
    children: [
      // {
      //   path: 'receiveddistributorproducts',
      //   component: () => import('@/views/imstijarah/receiveddistributorproducts'),
      //   meta: { relationRoles: ['Owner', 'Distributor'], title: 'Packed Products', icon: 'ow_clock1' }
      // },
      {
        path: 'purchaseorders',
        component: () => import('@/views/imstijarah/purchaseorders'),
        // meta: { title: '15 Admin Requests', icon: 'ow_clock1', badge: 'purchaseorder' }
        meta: { relationRoles: ['Distributor'], title: 'Receiving Products', icon: 'ow_clock1' }
      },
      {
        path: 'distributorprofiles',
        component: () => import('@/views/imstijarah/distributorprofiles'),
        meta: { relationRoles: ['Distributor'], title: 'Profile', icon: 'ow_clock1' }
      }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/imstijarah/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { relationRoles: ['Owner'], feature: 'imstijarah', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/imstijarah/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'imsteknobumi', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/imsteknobumi/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/imsteknobumi/productstocks'),
        meta: { title: 'Stock Control', icon: 'ow_clock1' }
      },
      {
        path: 'stocktakes',
        component: () => import('@/views/imsteknobumi/stocktakes'),
        meta: { title: 'Stock Take', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/imsteknobumi/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
      // {
      //   path: 'transactionlogs',
      //   component: () => import('@/views/imsteknobumi/transactionlogs'),
      //   meta: { title: '[WIP] Transaction Logs', icon: 'ow_clock1' }
      // }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { feature: 'imsteknobumi', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'whlocations',
        component: () => import('@/views/imsteknobumi/whlocations'),
        meta: { title: 'WHLocations', icon: 'ow_clock1' }
      },
      {
        path: 'categories',
        component: () => import('@/views/imsteknobumi/categories'),
        meta: { title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'products',
        component: () => import('@/views/imsteknobumi/products'),
        meta: { title: 'Product Code', icon: 'ow_clock1' }
      },
      {
        path: 'bom',
        component: () => import('@/views/imsteknobumi/finishedgoods'),
        meta: { title: 'BOM', icon: 'ow_clock1' }
      },
      // {
      //   path: 'parts',
      //   component: () => import('@/views/imsteknobumi/parts'),
      //   meta: { title: 'Parts', icon: 'ow_clock1' }
      // },
      {
        path: 'customers',
        component: () => import('@/views/imsteknobumi/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/imsteknobumi/suppliers'),
        meta: { title: 'Suppliers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'imsteknobumi', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'inboundqrcodes',
        component: () => import('@/views/imsteknobumi/partqrcodes'),
        meta: { title: '01 Warehouse QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'inboundscan',
        component: () => import('@/views/imsteknobumi/partscanlogs'),
        meta: { title: '02 Receiving Products', icon: 'ow_clock1' }
      },
      {
        path: 'packedproducts',
        component: () => import('@/views/imsteknobumi/packedproducts'),
        meta: { title: '03 Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'requestedwhparts',
        component: () => import('@/views/imsteknobumi/requestedwhparts'),
        meta: { title: '05 Requested Parts', icon: 'ow_clock1', badge: 'requestedwhpart' },
      },
      {
        path: 'requestedscansimulator',
        component: () => import('@/views/imsteknobumi/requestedwhpartscanlogs'),
        meta: { title: '06 Requested Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'receivedwhfinishedgoods',
        component: () => import('@/views/imsteknobumi/receivedwhproducts'),
        meta: { title: '11 Inbound Verify', icon: 'ow_clock1' }
      },
      {
        path: 'cartonqrcodes',
        component: () => import('@/views/imsteknobumi/cartonqrcodes'),
        meta: { title: '12 Pallet QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'cartonpair',
        component: () => import('@/views/imsteknobumi/cartonscanlogs'),
        meta: { title: '13 Pallet Pair', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartons',
        component: () => import('@/views/imsteknobumi/packedcartons'),
        meta: { title: '14 Packed Pallets', icon: 'ow_clock1' }
      },
      {
        path: 'purchaseorders',
        component: () => import('@/views/imsteknobumi/purchaseorders'),
        meta: { title: '15 Admin Requests', icon: 'ow_clock1', badge: 'purchaseorder' }
      },
      {
        path: 'packinglistpair',
        component: () => import('@/views/imsteknobumi/packinglistscanlogs'),
        meta: { title: '16 Packing Lists', icon: 'ow_clock1' }
      },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/workorders'),
      //   meta: { title: '[WIP] Packing Lists', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestedwhparts'),
      //   meta: { title: '[WIP] 5 Requested Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestedwhpartscanlogs'),
      //   meta: { title: '[WIP] 6 Requested Scan Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/receivedwhproducts'),
      //   meta: { title: '[WIP] 12 Received Cartons', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/cartonqrcodes'),
      //   meta: { title: '[WIP] 13 Generate Pallet QR', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedcartonscanlogs'),
      //   meta: { title: '[WIP] 14 Pallet Scan Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/workorders'),
      //   meta: { title: '[WIP] 15 Packed Pallets', icon: 'ow_clock1' }
      // }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/production',
    component: Layout,
    redirect: '',
    name: 'Production',
    meta: { relationRoles: ['Owner', 'Production'], feature: 'imsteknobumi', title: 'Production', icon: 'ow_clock1' },
    children: [
      {
        path: 'requestprparts',
        component: () => import('@/views/imsteknobumi/requestprparts'),
        meta: { title: '04 Parts Request', icon: 'ow_clock1' }
      },
      {
        path: 'receivedprparts',
        component: () => import('@/views/imsteknobumi/receivedprparts'),
        meta: { title: '07 Received Parts', icon: 'ow_clock1' }
      },
      {
        path: 'produceqrcodes',
        component: () => import('@/views/imsteknobumi/productqrcodes'),
        meta: { title: '08 Production QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'producescan',
        component: () => import('@/views/imsteknobumi/productscanlogs'),
        meta: { title: '09 Produce Scan', icon: 'ow_clock1' }
      },
      {
        path: 'packedfinishedgoods',
        component: () => import('@/views/imsteknobumi/packedproductsproduction'),
        meta: { title: '10 Packed Cartons', icon: 'ow_clock1' }
      },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestprparts'),
      //   meta: { title: '[WIP] 4 Parts Request', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedpartprs'),
      //   meta: { title: '[WIP] 7 Packed Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/receivedprparts'),
      //   meta: { title: '[WIP] 8 Received Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/productqrcodes'),
      //   meta: { title: '[WIP] 9 Generate Cartons QR', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedproductweightlogs'),
      //   meta: { title: '[WIP] 10 Weight Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedproducts'),
      //   meta: { title: '[WIP] 11 Packed Cartons', icon: 'ow_clock1' }
      // }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/warranty',
    component: Layout,
    redirect: '',
    name: 'Warranty Tracking',
    meta: { relationRoles: ['Owner'], feature: 'imsteknobumi', title: 'Warranty Tracking', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/imsteknobumi/productwarranties'),
        meta: { title: 'Product Warranties', icon: 'ow_clock1' }
      }
    ],
    branch: true,
    alwaysShow: true
  },
  {
    path: '/z/:branchId/imsteknobumi/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { feature: 'imsteknobumi', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/imsteknobumi/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  /*
  {
    path: '/z/:branchId/imsteknobumi/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'imsteknobumi', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/imsteknobumi/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'partinventories',
        component: () => import('@/views/imsteknobumi/partinventories'),
        meta: { title: 'Stock Control', icon: 'ow_clock1' }
      },
      {
        path: 'transactionlogs',
        component: () => import('@/views/imsteknobumi/transactionlogs'),
        meta: { title: 'Transaction Logs', icon: 'ow_clock1' }
      },
      {
        path: 'packinglists',
        component: () => import('@/views/imsteknobumi/packinglists'),
        meta: { title: '16 Packing List', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/imsteknobumi/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'imsteknobumi', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'whlocations',
        component: () => import('@/views/imsteknobumi/whlocations'),
        meta: { relationRoles: ['Owner'], title: 'WHLocations', icon: 'ow_clock1' }
      },
      {
        path: 'categories',
        component: () => import('@/views/imsteknobumi/categories'),
        meta: { relationRoles: ['Owner'], title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'finishedgoods',
        component: () => import('@/views/imsteknobumi/products'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Finished Goods', icon: 'ow_clock1' }
      },
      {
        path: 'parts',
        component: () => import('@/views/imsteknobumi/parts'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Parts', icon: 'ow_clock1' }
      },
      {
        path: 'tools',
        component: () => import('@/views/imsteknobumi/tools'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Tools', icon: 'ow_clock1' }
      },
      {
        path: 'bom',
        component: () => import('@/views/imsteknobumi/boms'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'BOM', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/imsteknobumi/customers'),
        meta: { relationRoles: ['Owner'], title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/imsteknobumi/suppliers'),
        meta: { relationRoles: ['Owner'], title: 'Suppliers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'imsteknobumi', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'partqrcodes',
        component: () => import('@/views/imsteknobumi/partqrcodes'),
        meta: { title: '1 Generate QR', icon: 'ow_clock1' }
      },
      {
        path: 'partweightsimulator',
        component: () => import('@/views/imsteknobumi/packedpartweightlogs'),
        meta: { title: '2 Weight Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedparts',
        component: () => import('@/views/imsteknobumi/packedparts'),
        meta: { title: '3 Packed Parts', icon: 'ow_clock1' }
      },
      {
        path: 'requestedwhparts',
        component: () => import('@/views/imsteknobumi/requestedwhparts'),
        meta: { title: '5 Requested Parts', icon: 'ow_clock1' }
      },
      {
        path: 'requestedscansimulator',
        component: () => import('@/views/imsteknobumi/requestedwhpartscanlogs'),
        meta: { title: '6 Requested Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'receivedwhfinishedgoods',
        component: () => import('@/views/imsteknobumi/receivedwhproducts'),
        meta: { title: '12 Received Cartons', icon: 'ow_clock1' }
      },
      {
        path: 'cartonqrcodes',
        component: () => import('@/views/imsteknobumi/cartonqrcodes'),
        meta: { title: '13 Generate Pallet QR', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartonscanlogs',
        component: () => import('@/views/imsteknobumi/packedcartonscanlogs'),
        meta: { title: '14 Pallet Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'workorders',
        component: () => import('@/views/imsteknobumi/workorders'),
        meta: { title: '15 Packed Pallets', icon: 'ow_clock1' }
      },
      // {
      //   path: 'workorders',
      //   component: () => import('@/views/imsteknobumi/workorders'),
      //   meta: { title: '15 Packed Pallets', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'packinglistscanlogs',
      //   component: () => import('@/views/imsteknobumi/packinglistscanlogs'),
      //   meta: { title: '16 Send Packing List', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'customercartonscanlogs',
      //   component: () => import('@/views/imsteknobumi/customercartonscanlogs'),
      //   meta: { title: '17 Send Customer Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'customercartons',
      //   component: () => import('@/views/imsteknobumi/customercartons'),
      //   meta: { title: '18 Customer Cartons', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/production',
    component: Layout,
    redirect: '',
    name: 'Production',
    meta: { relationRoles: ['Owner', 'Production'], feature: 'imsteknobumi', title: 'Production', icon: 'ow_clock1' },
    children: [
      {
        path: 'requestprparts',
        component: () => import('@/views/imsteknobumi/requestprparts'),
        meta: { title: '4 Parts Request', icon: 'ow_clock1' }
      },
      {
        path: 'packedparts',
        component: () => import('@/views/imsteknobumi/packedpartprs'),
        meta: { title: '7 Packed Parts', icon: 'ow_clock1' }
      },
      {
        path: 'receivedprparts',
        component: () => import('@/views/imsteknobumi/receivedprparts'),
        meta: { title: '8 Received Parts', icon: 'ow_clock1' }
      },
      {
        path: 'productqrcodes',
        component: () => import('@/views/imsteknobumi/productqrcodes'),
        meta: { title: '9 Generate Cartons QR', icon: 'ow_clock1' }
      },
      {
        path: 'productweightsimulator',
        component: () => import('@/views/imsteknobumi/packedproductweightlogs'),
        meta: { title: '10 Weight Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedfinishedgoods',
        component: () => import('@/views/imsteknobumi/packedproducts'),
        meta: { title: '11 Packed Cartons', icon: 'ow_clock1' }
      },
      // {
      //   path: 'packedcartons',
      //   component: () => import('@/views/imsteknobumi/packedcartons'),
      //   meta: { title: '13 Packed Cartons', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'receivedwhproductscanlogs',
      //   component: () => import('@/views/imsteknobumi/receivedwhproductscanlogs'),
      //   meta: { title: '14 Send Carton Simulator', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/imsteknobumi/warranty',
    component: Layout,
    redirect: '',
    name: 'Warranty',
    meta: { relationRoles: ['Owner'], feature: 'imsteknobumi', title: 'Warranty', icon: 'ow_clock1' },
    children: [
      {
        path: 'warrantyproducts',
        component: () => import('@/views/imsteknobumi/warrantyproducts'),
        meta: { title: 'Finished Goods Warranty', icon: 'ow_clock1' }
      },
      {
        path: 'warrantytools',
        component: () => import('@/views/imsteknobumi/warrantytools'),
        meta: { title: 'Tools Warranty', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  */
  {
    path: '/z/:branchId/sipp/overview',
    component: Layout,
    redirect: '',
    name: 'SIPP',
    meta: { sippPackages: ['', 'qrsipp'], feature: 'sipp', title: 'Overview', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/overview'),
        meta: { title: 'SIPP', icon: 'ow_clock1' }
      }
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/sipp/ims',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { sippModule: 'ims', feature: 'sipp', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/sipp/productstocks'),
        meta: { title: 'Stock Control', icon: 'ow_clock1' }
      },
      {
        path: 'stocktakes',
        component: () => import('@/views/sipp/stocktakes'),
        meta: { title: 'Stock Take', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/sipp/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
      // {
      //   path: 'transactionlogs',
      //   component: () => import('@/views/imsteknobumi/transactionlogs'),
      //   meta: { title: '[WIP] Transaction Logs', icon: 'ow_clock1' }
      // }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/sipp/ims/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { sippModule: 'ims', feature: 'sipp', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'whlocations',
        component: () => import('@/views/sipp/whlocations'),
        meta: { title: 'WHLocations', icon: 'ow_clock1' }
      },
      {
        path: 'categories',
        component: () => import('@/views/sipp/categories'),
        meta: { title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/sipp/suppliers'),
        meta: { title: 'Suppliers', icon: 'ow_clock1' }
      },
      {
        path: 'products',
        component: () => import('@/views/sipp/products'),
        meta: { title: 'Product Code', icon: 'ow_clock1' }
      },
      {
        path: 'bom',
        component: () => import('@/views/sipp/finishedgoods'),
        meta: { title: 'BOM', icon: 'ow_clock1' }
      },
      // {
      //   path: 'parts',
      //   component: () => import('@/views/sipp/parts'),
      //   meta: { title: 'Parts', icon: 'ow_clock1' }
      // },
      {
        path: 'customers',
        component: () => import('@/views/sipp/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/ims/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { sippModule: 'ims', feature: 'sipp', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'inboundqrcodes',
        component: () => import('@/views/sipp/partqrcodes'),
        meta: { title: '01 Warehouse QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'inboundscan',
        component: () => import('@/views/sipp/partscanlogs'),
        meta: { title: '02 Receiving Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedproducts',
        component: () => import('@/views/sipp/packedproducts'),
        meta: { title: '03 Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'requestedwhparts',
        component: () => import('@/views/sipp/requestedwhparts'),
        meta: { title: '05 Requested Parts (View Only)', icon: 'ow_clock1', badge: 'requestedwhpart' },
      },
      {
        path: 'requestedscansimulator',
        component: () => import('@/views/sipp/requestedwhpartscanlogs'),
        meta: { title: '06 Requested Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'receivedwhfinishedgoods',
        component: () => import('@/views/sipp/receivedwhproducts'),
        meta: { title: '11 Inbound Verify', icon: 'ow_clock1' }
      },
      {
        path: 'cartonqrcodes',
        component: () => import('@/views/sipp/cartonqrcodes'),
        meta: { title: '12 Pallet/Carton QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'cartonpair',
        component: () => import('@/views/sipp/cartonscanlogs'),
        meta: { title: '13 Pallet/Carton Pair Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartons',
        component: () => import('@/views/sipp/packedcartons'),
        meta: { title: '14 Packed Pallets/Cartons', icon: 'ow_clock1' }
      },
      {
        path: 'purchaseorders',
        component: () => import('@/views/sipp/purchaseorders'),
        meta: { title: '15 Admin Requests', icon: 'ow_clock1', badge: 'purchaseorder' }
      },
      {
        path: 'packinglistpair',
        component: () => import('@/views/sipp/packinglistscanlogs'),
        meta: { title: '16 Packing List Simulator', icon: 'ow_clock1' }
      },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/workorders'),
      //   meta: { title: '[WIP] Packing Lists', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestedwhparts'),
      //   meta: { title: '[WIP] 5 Requested Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestedwhpartscanlogs'),
      //   meta: { title: '[WIP] 6 Requested Scan Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/receivedwhproducts'),
      //   meta: { title: '[WIP] 12 Received Cartons', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/cartonqrcodes'),
      //   meta: { title: '[WIP] 13 Generate Pallet QR', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedcartonscanlogs'),
      //   meta: { title: '[WIP] 14 Pallet Scan Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/workorders'),
      //   meta: { title: '[WIP] 15 Packed Pallets', icon: 'ow_clock1' }
      // }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/ims/production',
    component: Layout,
    redirect: '',
    name: 'Production',
    meta: { sippModule: 'ims', feature: 'sipp', title: 'Production', icon: 'ow_clock1' },
    children: [
      {
        path: 'requestprparts',
        component: () => import('@/views/sipp/requestprparts'),
        meta: { title: '04 Parts Request', icon: 'ow_clock1' }
      },
      {
        path: 'receivedprparts',
        component: () => import('@/views/sipp/receivedprparts'),
        meta: { title: '07 Received Parts', icon: 'ow_clock1' }
      },
      {
        path: 'produceqrcodes',
        component: () => import('@/views/sipp/productqrcodes'),
        meta: { title: '08 Production QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'producescan',
        component: () => import('@/views/sipp/productscanlogs'),
        meta: { title: '09 Produce Scan Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'packedfinishedgoods',
        component: () => import('@/views/sipp/packedproductsproduction'),
        meta: { title: '10 Packed Cartons/Products', icon: 'ow_clock1' }
      },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/requestprparts'),
      //   meta: { title: '[WIP] 4 Parts Request', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedpartprs'),
      //   meta: { title: '[WIP] 7 Packed Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/receivedprparts'),
      //   meta: { title: '[WIP] 8 Received Parts', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/productqrcodes'),
      //   meta: { title: '[WIP] 9 Generate Cartons QR', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedproductweightlogs'),
      //   meta: { title: '[WIP] 10 Weight Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'abc',
      //   component: () => import('@/views/imsteknobumi/packedproducts'),
      //   meta: { title: '[WIP] 11 Packed Cartons', icon: 'ow_clock1' }
      // }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/tepad',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { sippModule: 'tepad', feature: 'sipp', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/tepaddashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/sipp/tepadreporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/sipp/tepad/tracking',
    component: Layout,
    redirect: '',
    name: 'Tracking',
    meta: { sippModule: 'tepad', feature: 'sipp', title: 'Tracking', icon: 'ow_clock1' },
    children: [
      {
        path: 'tepadproducts',
        component: () => import('@/views/sipp/tepadproducts'),
        meta: { title: 'TePaD Product Code', icon: 'ow_clock1' }
      },
      {
        path: 'workorders',
        component: () => import('@/views/sipp/tepadworkorders'),
        meta: { title: 'TePaD Work Orders', icon: 'ow_clock1' }
      },
      {
        path: 'printerlogs',
        component: () => import('@/views/sipp/printerlogs'),
        meta: { title: 'Printer Logs', icon: 'ow_clock1' }
      },
      // {
      //   path: 'productqrcodes',
      //   component: () => import('@/views/syntomax/productqrcodes'),
      //   meta: { title: '[WIP] PR - 11 Printer Products', icon: 'ow_clock1' }
      // },
      {
        path: 'scanlogs',
        component: () => import('@/views/sipp/scanlogs'),
        meta: { title: 'Scanner Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'tepadpackedproducts',
        component: () => import('@/views/sipp/tepadpackedproducts'),
        meta: { title: 'TePaD Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'tepadpackedcartons',
        component: () => import('@/views/sipp/tepadpackedcartons'),
        meta: { title: 'TePaD Packed Pallets', icon: 'ow_clock1' }
      },
      {
        path: 'inboundoutboundhub',
        component: () => import('@/views/sipp/inboundoutboundhub'),
        meta: { title: 'TePaD Inbound/Outbound', icon: 'ow_clock1' }
      },
      {
        path: 'inboundscanlogs',
        component: () => import('@/views/sipp/inboundscanlogs'),
        meta: { title: 'TePaD Inbound Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'outboundscanlogs',
        component: () => import('@/views/sipp/outboundscanlogs'),
        meta: { title: 'TePaD Outbound Simulator', icon: 'ow_clock1' }
      },
      // {
      //   path: 'batches',
      //   component: () => import('@/views/syntomax/batches'),
      //   meta: { title: '[WIP] Batches', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/product',
    component: Layout,
    redirect: '',
    name: 'Product Information',
    meta: { sippModule: 'product', feature: 'sipp', title: 'Product Information', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/productinformations'),
        meta: { title: 'Packed Products', icon: 'ow_clock1' }
      }
    ],
    branch: true,
    alwaysShow: true
  },
  {
    path: '/z/:branchId/sipp/warranty',
    component: Layout,
    redirect: '',
    name: 'Warranty Tracking',
    meta: { sippModule: 'warranty', feature: 'sipp', title: 'Warranty Tracking', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/productwarranties'),
        meta: { title: 'Product Warranties', icon: 'ow_clock1' }
      }
    ],
    branch: true,
    alwaysShow: true
  },
  {
    path: '/z/:branchId/sipp/ims/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { sippModule: 'ims', feature: 'sipp', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/tepad/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { sippModule: 'tepad', feature: 'sipp', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/product/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { sippModule: 'product', feature: 'sipp', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/warranty/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { sippModule: 'warranty', feature: 'sipp', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  // ENIGMA package: SIPP trimmed to Register -> QRCode -> Scan -> Packed Products,
  // combined with Product Information. Reuses the SIPP views and endpoints as-is;
  // only branches whose sipp feature carries package 'qrsipp' see these routes.
  {
    path: '/z/:branchId/sipp/qrsipp',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { sippPackages: ['qrsipp'], sippModule: 'qrsipp', feature: 'sipp', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/sipp/productstocks'),
        meta: { title: 'Stock Control', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/sipp/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/sipp/qrsipp/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { sippPackages: ['qrsipp'], sippModule: 'qrsipp', feature: 'sipp', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'categories',
        component: () => import('@/views/sipp/categories'),
        meta: { title: 'Categories', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/sipp/suppliers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'products',
        component: () => import('@/views/sipp/products'),
        meta: { title: 'Product Code', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/qrsipp/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { sippPackages: ['qrsipp'], sippModule: 'qrsipp', feature: 'sipp', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'inboundqrcodes',
        component: () => import('@/views/sipp/partqrcodes'),
        meta: { title: '01 Warehouse QRCode', icon: 'ow_clock1' }
      },
      {
        path: 'inboundscan',
        component: () => import('@/views/sipp/partscanlogs'),
        meta: { title: '02 Create Products', icon: 'ow_clock1' }
      },
      {
        path: 'packedproducts',
        component: () => import('@/views/sipp/packedproducts'),
        meta: { title: '03 Packed Products', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipp/qrsipp/product',
    component: Layout,
    redirect: '',
    name: 'Product Information',
    meta: { sippPackages: ['qrsipp'], sippModule: 'qrsipp', feature: 'sipp', title: 'Product Information', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/productinformations'),
        meta: { title: 'Packed Products', icon: 'ow_clock1' }
      }
    ],
    branch: true,
    alwaysShow: true
  },
  {
    path: '/z/:branchId/sipp/qrsipp/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { sippPackages: ['qrsipp'], sippModule: 'qrsipp', feature: 'sipp', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/sipp/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/maintenance',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Maintenance Service',
  //   meta: { feature: 'sipp', title: 'Maintenance Service', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/sippmaintenance/dashboard'),
  //       meta: { title: 'Dashboard', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'products',
  //       component: () => import('@/views/sippmaintenance/products'),
  //       meta: { title: 'Products', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'maintenance',
  //       component: () => import('@/views/sippmaintenance/productwarehouses'),
  //       meta: { title: 'Maintenance', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/warisan/reporting',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Reporting',
  //   meta: { feature: 'warisan', title: 'Reporting', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/warisan/dashboard'),
  //       meta: { title: 'Dashboard', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'stockcontrol',
  //       component: () => import('@/views/warisan/stockcontrol'),
  //       meta: { title: 'Stock Control', icon: 'ow_clock1' }
  //     },
  //     // {
  //     //   path: 'transactionlogs',
  //     //   component: () => import('@/views/warisan/transactionlogs'),
  //     //   meta: { title: 'Transaction Logs', icon: 'ow_clock1' }
  //     // },
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  {
    path: '/z/:branchId/warisan/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'warisan', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/warisan/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'productinventories',
        component: () => import('@/views/warisan/productinventories'),
        meta: { relationRoles: ['Owner'], title: 'Stock', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/warisan/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { feature: 'warisan', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'products',
        component: () => import('@/views/warisan/products'),
        meta: { title: 'Products', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/warisan/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/warisan/transactions',
    component: Layout,
    redirect: '',
    name: 'TePaD',
    meta: { feature: 'warisan', title: 'TePaD', icon: 'ow_clock1' },
    children: [
      {
        path: 'printerlogs',
        component: () => import('@/views/warisan/printerlogs'),
        meta: { title: 'Printer Logs', icon: 'ow_clock1' }
      },
      {
        path: 'productqrcodes',
        component: () => import('@/views/warisan/productqrcodes'),
        meta: { title: 'Printer Products', icon: 'ow_clock1' }
      },
      {
        path: 'scanlogs',
        component: () => import('@/views/warisan/scanlogs'),
        meta: { title: 'Scanner Logs', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/warisan/production',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { feature: 'warisan', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'packedproducts',
        component: () => import('@/views/warisan/packedproducts'),
        meta: { title: 'Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'workorders',
        component: () => import('@/views/warisan/workorders'),
        meta: { title: 'Purchase Order', icon: 'ow_clock1' }
      },
      {
        path: 'cartonqr',
        component: () => import('@/views/warisan/palletqrcodes'),
        meta: { title: 'Generate Carton QR', icon: 'ow_clock1' }
      },
      // {
      //   path: 'palletsimulator',
      //   component: () => import('@/views/warisan/packedpalletscanlogs'),
      //   meta: { title: 'Pallet Simulator', icon: 'ow_clock1' }
      // },
      {
        path: 'packinglist',
        component: () => import('@/views/warisan/packedpallets'),
        meta: { title: 'Packing List', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/warisan/operations',
    component: Layout,
    redirect: '',
    name: 'Operations',
    meta: { feature: 'warisan', title: 'Operations', icon: 'ow_clock1' },
    children: [
      // {
      //   path: 'scanlogsimulator',
      //   component: () => import('@/views/warisan/scanlogsimulator'),
      //   meta: { title: 'Scanner Reader', icon: 'ow_clock1' }
      // },
      {
        path: 'scanlogsiframe',
        component: () => import('@/views/warisan/scanlogsiframe'),
        meta: { title: 'Scanner Page', icon: 'ow_clock1' }
      },
      {
        path: 'printiframe',
        component: () => import('@/views/warisan/printiframe'),
        meta: { title: 'Printer Page', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'syntomax', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/syntomax/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'productinventories',
        component: () => import('@/views/syntomax/productinventories'),
        meta: { relationRoles: ['Owner'], title: 'Stock', icon: 'ow_clock1' }
      },
      {
        path: 'transactionlogs',
        component: () => import('@/views/syntomax/transactionlogs'),
        meta: { title: 'Transaction Logs', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/syntomax/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { feature: 'syntomax', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'products',
        component: () => import('@/views/syntomax/products'),
        meta: { title: 'Products', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/syntomax/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/syntomax/suppliers'),
        meta: { title: 'Suppliers', icon: 'ow_clock1' }
      },
      {
        path: 'locations',
        component: () => import('@/views/syntomax/locations'),
        meta: { title: 'Rack Locations', icon: 'ow_clock1' }
      },
      // {
      //   path: 'rawmaterials',
      //   component: () => import('@/views/syntomax/rawmaterials'),
      //   meta: { title: 'Raw Material', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'stock',
      //   component: () => import('@/views/syntomax/stock'),
      //   meta: { title: 'Stock', icon: 'ow_clock1' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/ims',
    component: Layout,
    redirect: '',
    name: 'IMS',
    meta: { feature: 'syntomax', title: 'IMS', icon: 'ow_clock1' },
    children: [
      {
        path: 'tanks',
        component: () => import('@/views/syntomax/tanks'),
        meta: { title: 'Tanks', icon: 'ow_clock1' }
      },
      // {
      //   path: 'tickets',
      //   component: () => import('@/views/syntomax/tickets'),
      //   meta: { title: 'Tickets', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'tanktickets',
      //   component: () => import('@/views/syntomax/tanktickets'),
      //   meta: { title: 'Tank Ticket Simulator', icon: 'ow_clock1' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { feature: 'syntomax', title: 'Warehouse', icon: 'ow_clock1' },
    children: [
      // {
      //   path: 'rawmaterialamountlogs',
      //   component: () => import('@/views/syntomax/rawmaterialamountlogs'),
      //   meta: { title: '1 Raw Material Simulator', icon: 'ow_clock1' }
      // },
      {
        path: 'workorders',
        component: () => import('@/views/syntomax/workorders'),
        meta: { title: '1) Purchase Order', icon: 'ow_clock1' }
      },
      {
        path: 'packedproducts',
        component: () => import('@/views/syntomax/packedproducts'),
        meta: { title: '5) Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartons',
        component: () => import('@/views/syntomax/packedcartons'),
        meta: { title: '6) Packed Cartons', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/tepad',
    component: Layout,
    redirect: '',
    name: 'TePad',
    meta: { feature: 'syntomax', title: 'TePad', icon: 'ow_clock1' },
    children: [
      {
        path: 'printerlogs',
        component: () => import('@/views/syntomax/printerlogs'),
        meta: { title: '2) Printer Logs', icon: 'ow_clock1' }
      },
      {
        path: 'productqrcodes',
        component: () => import('@/views/syntomax/productqrcodes'),
        meta: { title: '3) Printer Products', icon: 'ow_clock1' }
      },
      {
        path: 'scanlogs',
        component: () => import('@/views/syntomax/scanlogs'),
        meta: { title: '4) Scanner Logs', icon: 'ow_clock1' }
      },
      {
        path: 'batches',
        component: () => import('@/views/syntomax/batches'),
        meta: { title: 'Batches', icon: 'ow_clock1' }
      },
      // {
      //   path: 'batchnumbers',
      //   component: () => import('@/views/syntomax/batchnumbers'),
      //   meta: { title: '5) Batch No.', icon: 'ow_clock1' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/syntomax/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { feature: 'syntomax', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/syntomax/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/syntomax/reporting',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Reporting',
  //   meta: { feature: 'syntomax', title: 'Reporting', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'scanlogs',
  //       component: () => import('@/views/syntomax/scanlogs'),
  //       meta: { title: 'Scanner Logs', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'printerlogs',
  //       component: () => import('@/views/syntomax/printerlogs'),
  //       meta: { title: 'Printer Logs', icon: 'ow_clock1' }
  //     },
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/syntomax/register',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Register',
  //   meta: { feature: 'syntomax', title: 'Register', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'products',
  //       component: () => import('@/views/syntomax/products'),
  //       meta: { title: 'Products', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'customers',
  //       component: () => import('@/views/syntomax/customers'),
  //       meta: { title: 'Customers', icon: 'ow_clock1' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/syntomax',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Syntomax',
  //   meta: { feature: 'syntomax', title: 'Syntomax', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'scanlogsimulator',
  //       component: () => import('@/views/syntomax/scanlogsimulator'),
  //       meta: { title: 'Scanner Reader', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'scanlogsiframe',
  //       component: () => import('@/views/syntomax/scanlogsiframe'),
  //       meta: { title: 'Scanner Page', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'productqrcodes',
  //       component: () => import('@/views/syntomax/productqrcodes'),
  //       meta: { title: 'Printer Products', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'printiframe',
  //       component: () => import('@/views/syntomax/printiframe'),
  //       meta: { title: 'Printer Page', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/sipro/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'sipro', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/sipro/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'stockrawmaterials',
        component: () => import('@/views/sipro/stockrawmaterials'),
        meta: { title: 'Stock Raw Material', icon: 'ow_clock1' }
      },
      {
        path: 'stockfinishedgoods',
        component: () => import('@/views/sipro/stockfinishedgoods'),
        meta: { title: 'Stock Finished Good', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/sipro/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipro/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'sipro', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'rawmaterials',
        component: () => import('@/views/sipro/rawmaterials'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Raw Material', icon: 'ow_clock1' }
      },
      {
        path: 'childparts',
        component: () => import('@/views/sipro/childparts'),
        meta: { title: 'Child Parts', icon: 'ow_clock1' }
      },
      {
        path: 'finishedgoods',
        component: () => import('@/views/sipro/products'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Finished Goods', icon: 'ow_clock1' }
      },
      {
        path: 'bom',
        component: () => import('@/views/sipro/boms'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'BOM Raw Materials', icon: 'ow_clock1' }
      },
      {
        path: 'bomchildparts',
        component: () => import('@/views/sipro/bomchildparts'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'BOM Child Parts', icon: 'ow_clock1' }
      },
      // {
      //   path: 'polyboxes',
      //   component: () => import('@/views/sipro/polyboxes'),
      //   meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Polybox', icon: 'ow_clock1' }
      // },
      {
        path: 'machines',
        component: () => import('@/views/sipro/machines'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Machines', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/sipro/customers'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Customers', icon: 'ow_clock1' }
      },
      {
        path: 'suppliers',
        component: () => import('@/views/sipro/suppliers'),
        meta: { relationRoles: ['Owner', 'Warehouse'], title: 'Suppliers', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipro/cpwarehouse',
    component: Layout,
    redirect: '',
    name: 'CP Warehouse',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'sipro', title: 'CP Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'rawmaterialamountlogs',
        component: () => import('@/views/sipro/rawmaterialamountlogs'),
        meta: { title: '1) Raw Material Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'requestedwhrawmaterials',
        component: () => import('@/views/sipro/requestedwhrawmaterials'),
        meta: { title: '3) Requested Raw Material', icon: 'ow_clock1' }
      },
      // {
      //   path: 'requestedscansimulator',
      //   component: () => import('@/views/sipro/requestedwhrawmaterialscanlogs'),
      //   meta: { title: '4 Requested Scan Simulator', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipro/production',
    component: Layout,
    redirect: '',
    name: 'Production',
    meta: { relationRoles: ['Owner', 'Production'], feature: 'sipro', title: 'Production', icon: 'ow_clock1' },
    children: [
      {
        path: 'requestprrawmaterials',
        component: () => import('@/views/sipro/requestprrawmaterials'),
        meta: { title: '2) Create Lot No', icon: 'ow_clock1' }
      },
      {
        path: 'receivedprrawmaterials',
        component: () => import('@/views/sipro/receivedprrawmaterials'),
        meta: { title: '4) Received Raw Material', icon: 'ow_clock1' }
      },
      {
        path: 'workorders',
        component: () => import('@/views/sipro/workorders'),
        meta: { title: '5) Lot No/Do No/Date', icon: 'ow_clock1' }
      },
      // {
      //   path: 'imlabels',
      //   component: () => import('@/views/sipro/imlabels'),
      //   meta: { title: '6 Injection Moulding Labels', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'mouldsectionscanlogs',
      //   component: () => import('@/views/sipro/mouldsectionscanlogs'),
      //   meta: { title: '7 Mould Section Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'paintsectionscanlogs',
      //   component: () => import('@/views/sipro/paintsectionscanlogs'),
      //   meta: { title: '8 Paint Section Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'assemblesectionscanlogs',
      //   component: () => import('@/views/sipro/assemblesectionscanlogs'),
      //   meta: { title: '9 Assemble Section Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'wrapsectionscanlogs',
      //   component: () => import('@/views/sipro/wrapsectionscanlogs'),
      //   meta: { title: '10 Wrap Section Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'rejectsectionscanlogs',
      //   component: () => import('@/views/sipro/rejectsectionscanlogs'),
      //   meta: { title: '11 Reject Section Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'palletqr',
      //   component: () => import('@/views/sipro/palletqrcodes'),
      //   meta: { title: '7) Generate Pallet QR', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'palletsimulator',
      //   component: () => import('@/views/sipro/packedpalletscanlogs'),
      //   meta: { title: '7 Pallet Simulator', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'packinglist',
      //   component: () => import('@/views/sipro/packedpallets'),
      //   meta: { title: '8) Packed Pallets', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'receivepolybox',
      //   component: () => import('@/views/sipro/requestprrawmaterials'),
      //   meta: { title: '15 Receive Polybox', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/sipro/fgwarehouse',
    component: Layout,
    redirect: '',
    name: 'FG Warehouse',
    meta: { relationRoles: ['Owner', 'Warehouse'], feature: 'sipro', title: 'FG Warehouse', icon: 'ow_clock1' },
    children: [
      {
        path: 'deliveryorders',
        component: () => import('@/views/sipro/purchaseorders'),
        meta: { title: '6) Delivery Order', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ainmedicare/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'ainmedicare', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/ainmedicare/dashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'transactionlogs',
        component: () => import('@/views/ainmedicare/transactionlogs'),
        meta: { title: 'Transaction Logs', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/ainmedicare/reporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ainmedicare/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { feature: 'ainmedicare', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'products',
        component: () => import('@/views/ainmedicare/products'),
        meta: { title: 'Products', icon: 'ow_clock1' }
      },
      {
        path: 'customers',
        component: () => import('@/views/ainmedicare/customers'),
        meta: { title: 'Customers', icon: 'ow_clock1' }
      },
      // {
      //   path: 'batchmasters',
      //   component: () => import('@/views/ainmedicare/batchmasters'),
      //   meta: { title: 'Batch Masters', icon: 'ow_clock1' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ainmedicare/tepad',
    component: Layout,
    redirect: '',
    name: 'Tracking',
    meta: { feature: 'ainmedicare', title: 'Tracking', icon: 'ow_clock1' },
    children: [
      // {
      //   path: 'batchqrcodes',
      //   component: () => import('@/views/ainmedicare/batchqrcodes'),
      //   meta: { title: 'Printer Batches', icon: 'ow_clock1' }
      // },
      {
        path: 'printerlogs',
        component: () => import('@/views/ainmedicare/printerlogs'),
        meta: { title: '1) Printer Logs', icon: 'ow_clock1' }
      },
      {
        path: 'packedcartons',
        component: () => import('@/views/ainmedicare/packedcartons'),
        meta: { title: '2) Packed Cartons', icon: 'ow_clock1' }
      },
      {
        path: 'packedpallets',
        component: () => import('@/views/ainmedicare/packedpallets'),
        meta: { title: '3) Packed Pallets', icon: 'ow_clock1' }
      },
      {
        path: 'consignmentnotes',
        component: () => import('@/views/ainmedicare/conceivementnotes'),
        meta: { title: '4) Consignment Notes', icon: 'ow_clock1' }
      },
      {
        path: 'scanlogs',
        component: () => import('@/views/ainmedicare/scanlogs'),
        meta: { title: 'Scanner Logs', icon: 'ow_clock1' }
      },
      {
        path: 'gantry1scanlogs',
        component: () => import('@/views/ainmedicare/gantry1scanlogs'),
        meta: { title: 'Gantry 1 Logs', icon: 'ow_clock1' }
      },
      {
        path: 'gantry2scanlogs',
        component: () => import('@/views/ainmedicare/gantry2scanlogs'),
        meta: { title: 'Gantry 2 Logs', icon: 'ow_clock1' }
      },
      {
        path: 'outboundlogs',
        component: () => import('@/views/ainmedicare/outboundlogs'),
        meta: { title: 'Outbound Logs', icon: 'ow_clock1' }
      },
      // {
      //   path: 'packedduplexes',
      //   component: () => import('@/views/ainmedicare/packedduplexes'),
      //   meta: { title: 'Packed Duplex', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'gs1labels',
      //   component: () => import('@/views/ainmedicare/gs1labels'),
      //   meta: { title: 'GS1 Labels', icon: 'ow_clock1' }
      // },
      // {
      //   path: 'packedpalletscanlogs',
      //   component: () => import('@/views/ainmedicare/packedpalletscanlogs'),
      //   meta: { title: 'PackedPalletScanLogs', icon: 'ow_clock1' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ainmedicare/settings',
    component: Layout,
    redirect: '',
    name: 'Settings',
    meta: { feature: 'ainmedicare', title: 'Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'palletsystems',
        component: () => import('@/views/ainmedicare/palletsystems'),
        meta: { title: 'Pallet Systems', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/ainmedicare/production',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Warehouse',
  //   meta: { feature: 'ainmedicare', title: 'Warehouse', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: 'packedproducts',
  //       component: () => import('@/views/ainmedicare/packedproducts'),
  //       meta: { title: 'Packed Products', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'workorders',
  //       component: () => import('@/views/ainmedicare/workorders'),
  //       meta: { title: 'Purchase Order', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'palletqr',
  //       component: () => import('@/views/ainmedicare/palletqrcodes'),
  //       meta: { title: 'Generate Pallet QR', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'palletsimulator',
  //       component: () => import('@/views/ainmedicare/packedpalletscanlogs'),
  //       meta: { title: 'Pallet Simulator', icon: 'ow_clock1' }
  //     },
  //     {
  //       path: 'packinglist',
  //       component: () => import('@/views/ainmedicare/packedpallets'),
  //       meta: { title: 'Packing List', icon: 'ow_clock1' }
  //     },
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  {
    path: '/z/:branchId/ainmedicare/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { feature: 'ainmedicare', title: 'User Manual', icon: 'ow_clock1' },
    children: [
      {
        path: '',
        component: () => import('@/views/ainmedicare/pdfmanual'),
        meta: { title: 'User Manual', icon: 'ow_clock1' }
      },
      // {
      //   path: 'videomanual',
      //   component: () => import('@/views/syntomax/videomanual'),
      //   meta: { title: 'Video Manual', icon: 'ow_clock1' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/nims/reporting',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { feature: 'nims', title: 'Reporting', icon: 'ow_clock1' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/nims/tepaddashboard'),
        meta: { title: 'Dashboard', icon: 'ow_clock1' }
      },
      {
        path: 'reporting',
        component: () => import('@/views/nims/tepadreporting'),
        meta: { title: 'Reporting', icon: 'ow_clock1' }
      }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/nims/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { feature: 'nims', title: 'Register', icon: 'ow_clock1' },
    children: [
      {
        path: 'products',
        component: () => import('@/views/nims/tepadproducts'),
        meta: { title: 'TePaD Products', icon: 'ow_clock1' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/nims/tepad/tracking',
    component: Layout,
    redirect: '',
    name: 'Tracking',
    meta: { feature: 'nims', title: 'Tracking', icon: 'ow_clock1' },
    children: [
      {
        path: 'workorders',
        component: () => import('@/views/nims/tepadworkorders'),
        meta: { title: 'TePaD Work Orders', icon: 'ow_clock1' }
      },
      {
        path: 'printerlogs1',
        component: () => import('@/views/nims/printerlogs1'),
        meta: { title: 'Printer 1 Logs', icon: 'ow_clock1' }
      },
      {
        path: 'printerlogs1-alt',
        component: () => import('@/views/nims/printerlogs1-alt'),
        meta: { title: 'Printer 1 Logs', icon: 'ow_clock1' },
        hidden: true
      },
      {
        path: 'scanlogs1',
        component: () => import('@/views/nims/scanlogs1'),
        meta: { title: 'Scanner 1 Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'printerlogs2',
        component: () => import('@/views/nims/printerlogs2'),
        meta: { title: 'Printer 2 Logs', icon: 'ow_clock1' }
      },
      {
        path: 'scanlogs2',
        component: () => import('@/views/nims/scanlogs2'),
        meta: { title: 'Scanner 2 Simulator', icon: 'ow_clock1' }
      },
      {
        path: 'tepadpackedproducts',
        component: () => import('@/views/nims/tepadpackedproducts'),
        meta: { title: 'TePaD Packed Products', icon: 'ow_clock1' }
      },
      {
        path: 'tepadpackedcartons',
        component: () => import('@/views/nims/tepadpackedcartons'),
        meta: { title: 'TePaD Packed Cartons', icon: 'ow_clock1' }
      },
    ],
    branch: true
  },

  // default - has branch
  {
    path: '/z/:branchId/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email', icon: 'ow_clock1' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  {
    path: '/z/:branchId/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password', icon: 'ow_clock1' }
      }
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default', icon: 'ow_clock1' }
      }
    ],
    hidden: true,
    branch: true
  },

  // default - no branch
  {
    path: '/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email', icon: 'ow_clock1' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator', icon: 'ow_clock1' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings', icon: 'ow_clock1' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile', icon: 'ow_clock1' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password', icon: 'ow_clock1' }
      }
    ]
  },
  // {
  //   path: '/email',
  //   component: Layout,
  //   redirect: 'email',
  //   name: 'Email',
  //   meta: { title: 'Email', icon: 'ow_clock1' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/email/index'),
  //       meta: { title: 'Email', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/branches',
  //   component: Layout,
  //   redirect: 'branches',
  //   name: 'Branches',
  //   meta: { title: 'Branches' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/admin/companies/index'),
  //       meta: { title: 'Branches', icon: 'ow_clock1' }
  //     }
  //   ],
  //   branch: false
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   name: 'Dashboard',
  //   meta: { title: 'Dashboard' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     meta: { title: 'Dashboard', icon: 'el-icon-monitor' }
  //   },
  //   {
  //     path: 'instance',
  //     component: () => import('@/views/admin/dashboard/index'),
  //     name: 'New Instance',
  //     meta: { title: 'New Instance' },
  //     hidden: true
  //   }]
  // },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users', icon: 'ow_clock1' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js